import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import SkeletonTableLoad from "../../../components/SkeletonTableLoad";
import { AccommodationTable } from "../../../models/Admin/AccommodationTable";
import msalRestClient from "../../../services/clients/MsalRestClient";

const AccommodationTablesOverview = () => {

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [selectedVersion, setSelectedVersion] = useState<number>(1);
    const [tables, setTables] = useState<AccommodationTable[]>([]);

    useEffect(() => {
        fetchTables();
    }, []);

    /**
     * Method fetches a collection of all availiable tables.
     */
    async function fetchTables() {

        setIsLoading(true);

        /* Fetch data from backend service */
        msalRestClient.get<AccommodationTable[]>("/api/accommodation/autocomplete")
            .then(response => {
                if (response.status === 200) {
                    /* Set fetched AccommodationTables to the current state */
                    setTables(response.data);
                }
                else if (response.status === 204) {
                    /* No accommodationTables could be found for the specified filter, set state to empty collection */
                    setTables([]);
                }
            })
            .catch(error => { })
            .finally(() => setIsLoading(false));
    }

    /* JSX Element for Rendering within browser */
    return (
        <main className="container">
            <div className="row">

                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-body">
                            {
                                isLoading ? <SkeletonTableLoad columnCount={5} rowCount={15} striped={false} />
                                    :
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th colSpan={3}>
                                                    <label>Table</label>
                                                    <div className="input-group mt-2">
                                                        <select className="form-select mb-2" defaultValue={selectedVersion} onChange={e => setSelectedVersion(Number(e.target.value))}>
                                                            {
                                                                tables.map((value, index) => {
                                                                    return (
                                                                        <option value={value.id}>{value.name}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                        <div className="input-group-append">
                                                            <NavLink to={"/admin/accommodations/" + selectedVersion} className="btn btn-primary">
                                                                <i className="bi bi-pen"></i>
                                                            </NavLink>
                                                            <NavLink to={"/admin/accommodations/copy/" + selectedVersion} className="btn btn-warning">
                                                                <i className="bi bi-clipboard"></i>
                                                            </NavLink>
                                                            <NavLink to={"/admin/accommodations/create"} className="btn btn-success">
                                                                <i className="bi bi-plus-lg"></i>
                                                            </NavLink>
                                                        </div>
                                                    </div>
                                                </th>
                                            </tr>
                                            <tr>
                                                <th>#</th>
                                                <th>Country</th>
                                                <th>Refund</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                tables.find(x => x.id === selectedVersion)?.accommodationSet.sort(x => x.id).map((x, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{x.id}</td>
                                                            <td>{x.country}</td>
                                                            <td>{x.accommodation} &euro;</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </main>
    )

}
export default AccommodationTablesOverview;